<template>
  <div>
    <div>
      <div class="mb-5 mt-3">
        <img src="/img/arrow-left.svg" class="ml-3" height="30" @click="$router.back()" />
        <div class="col-12 text-center">
          <img src="/img/selo-color.svg" height="150" />
        </div>
      </div>
      <div class="row p-2 pt-5">
        <div class="col-md-12 col-sm-12">
          <ValidationObserver ref="dados" class="w-100">
            <form>
              <div class="mb-3">
                <ValidationProvider mode="passive" name="CPF" rules="required|cpf" v-slot="{ errors, classes }">
                  <div class="field">
                    <input :style="cpf && 'color: #0D4275'" type="tel" class="input" :class="classes" v-model="cpf"
                      @focus="clear" v-mask="'###.###.###-##'" maxlength="20" autocomplete="nope" />
                    <label :class="cpf && 'filled'">Qual é o seu CPF?</label>
                    <span class="invalid-feedback">{{ errors[0] }}</span>
                  </div>
                </ValidationProvider>
              </div>
              <div class="mb-2">
                <ValidationProvider name="senha" rules="required" mode="passive" v-slot="{ errors, classes }">
                  <div class="field">
                    <input :type="showPassword ? 'text' : 'password'" class="input" :style="senha && 'color: black'"
                      :class="classes" v-model="senha" @focus="clear" maxlength="100" autocomplete="nope" />
                    <label :class="senha && 'filled'">Digite sua senha</label>
                    <img class="hide-show" @click="togglePasswordVisibility"
                      :src="showPassword ? '/img/eye-closed.svg' : '/img/eye-open.svg'" />
                    <span class="invalid-feedback">{{ errors[0] }}</span>
                  </div>
                </ValidationProvider>
              </div>
            </form>
          </ValidationObserver>
          <button class="continue-btn mt-5" :disabled="loading" @click.prevent="handle">
            <span>ENTRAR</span>
          </button>
        </div>


      </div>
      <vue-bottom-sheet-vue2 ref="warning" drag-color="rgba(255, 255, 255, 0.5)">
        <div class="text-center pb-5">
          <h5 class="text-info">Não foi possivel enviar as informações</h5>
        </div>
      </vue-bottom-sheet-vue2>
      <vue-bottom-sheet-vue2 ref="notfound" drag-color="rgba(255, 255, 255, 0.5)">
        <div class="text-center pb-5">
          <h5 class="text-info">Usuario não encontrado</h5>
        </div>
      </vue-bottom-sheet-vue2>
      
      <vue-bottom-sheet-vue2 ref="required" drag-color="rgba(255, 255, 255, 0.5)">
        <div class="text-center pb-5">
          <h5 class="text-info">Escolha uma das opções</h5>
        </div>
      </vue-bottom-sheet-vue2>
    </div>
    <Loading v-if="loading" />
  </div>
</template>

<script>

import api from "../axiosConfig";
import VueBottomSheetVue2 from "@webzlodimir/vue-bottom-sheet-vue2";
import config from "../config";

export default {
  components: {
    VueBottomSheetVue2,
    Loading: () => import("./Loading.vue"),
  },
  data() {
    return {
      cpf: undefined,
      senha: undefined,
      showPassword: false,
      config,
      data: undefined,
      loading: false,
    };
  },
  created() {
  },
  mounted() {
  },
  watch: {
  },
  methods: {
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    clear() {
      this.$nextTick(() => {
        this.$refs.dados.reset();
      });
    },

    async handle() {
      const valid = await this.$refs.dados.validate();
      if (!valid) return;

      await this.save();
    },

    async save() {
      try {
        this.loading = true;

        var payload = {
          cpf: this.cpf,
          senha: this.senha,
        };

        const response = await api.post('/users/login', payload);

        const id = JSON.stringify(response.data.id);
        window.sessionStorage.setItem("idUsuario", id);

        this.loading = false;

        this.$router.push("/main");

      } catch (error) {
        this.loading = false;
        if (error.response.status === 404 || error.response.status === 401) {
          this.$refs.notfound.open();
          return;
        }

        this.$refs.warning.open();
      }
    },
  },
};
</script>
<style scoped>
.hide-show {
  position: absolute;
  right: 15px;
  top: 22px;
  transition: 0.2s ease all;
  cursor: pointer;
}
</style>
